module.exports = __webpack_public_path__ + "854552cf3155a6a04595a7556d4f9876.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/misc/speech-to-text.png
// module id = 189
// module chunks = 0